type FullStoryModule = typeof import('@fullstory/browser');
export type FullStoryPortal = 'f1' | 'clientPortal' | 'memberPortal';

type RuntimeFlagValue = boolean | string | number;

type RuntimeEnvironment = {
  ENABLE_FULLSTORY_F1?: RuntimeFlagValue;
  ENABLE_FULLSTORY_CLIENT_PORTAL?: RuntimeFlagValue;
  ENABLE_FULLSTORY_MEMBER_PORTAL?: RuntimeFlagValue;
  REACT_APP_FULLSTORY_ORG_ID?: string;
};

const { __environment__ } = window as Window & {
  __environment__: RuntimeEnvironment;
};

let initializationPromise: Promise<FullStoryModule | null> | null = null;

const portalFlagMap: Record<FullStoryPortal, keyof RuntimeEnvironment> = {
  f1: 'ENABLE_FULLSTORY_F1',
  clientPortal: 'ENABLE_FULLSTORY_CLIENT_PORTAL',
  memberPortal: 'ENABLE_FULLSTORY_MEMBER_PORTAL',
};

function isTruthyRuntimeFlag(value: RuntimeFlagValue | undefined) {
  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'number') {
    return value !== 0;
  }

  if (typeof value === 'string') {
    return ['1', 'on', 'true', 'yes'].includes(value.trim().toLowerCase());
  }

  return false;
}

export function isFullStoryEnabled(portal: FullStoryPortal) {
  return isTruthyRuntimeFlag(__environment__?.[portalFlagMap[portal]]);
}

export function initializeFullStory(portal: FullStoryPortal) {
  const fullStoryOrgId = __environment__?.REACT_APP_FULLSTORY_ORG_ID?.trim();

  if (!isFullStoryEnabled(portal) || !fullStoryOrgId) {
    return Promise.resolve(null);
  }

  if (!initializationPromise) {
    initializationPromise = import('@fullstory/browser').then((fullStory) => {
      fullStory.init({ orgId: fullStoryOrgId });
      return fullStory;
    });
  }

  return initializationPromise;
}

export function setFullStoryUser(
  portal: FullStoryPortal,
  emailAddress?: string | null,
) {
  if (!emailAddress) {
    return;
  }

  void initializeFullStory(portal).then((fullStory) => {
    if (!fullStory) {
      return;
    }

    fullStory.FullStory('setProperties', {
      type: 'user',
      properties: {
        email: emailAddress,
      },
    });
  });
}
